/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/app-download'>.
 * внешний редирект в сторы
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import AppRedirect from '@routes/AppRedirect';

export const Route = createFileRoute('/app-download')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={AppRedirect} path='/app-download' />
  )
});
